import React from "react";
import styles from "./slider.module.css";
import { Col, Container, Row } from "react-bootstrap";
import { Heading, Paragraph } from "../TextComponents/TextComponents";

const Section = () => {
  return (
    <React.Fragment>
      <Container>
        <Row>
          <Col sm={12} md={6}>
            <Heading>Life at CrossBorder BTC</Heading>
            <Paragraph>
              Discover what it’s like to work with a team that values your{" "}
              <br /> contributions and celebrates your success.
            </Paragraph>
          </Col>
          <Col sm={12} md={6}>
            <div className={styles.btn}>
              <button>Apply Now</button>
            </div>
          </Col>
        </Row>
      </Container>

      <Container>
        <Row>
          <Col md={4} sm={12}>
            <div className={styles.cardSection}>
              <img  loading="lazy" src="/images/Carrer/img_3.png" alt="user" />
              <p>
                CrossBorder BTC gave me the opportunity to work on international
                projects, expanding my skills and network.
              </p>
            </div>
          </Col>
          <Col md={4} sm={12}>
            <div className={styles.cardSection}>
              <img  loading="lazy" src="/images/Carrer/img_2.png" alt="user" />
              <p>
                The inclusive culture here makes it a joy to come to work every
                day.
              </p>
            </div>
          </Col>
          <Col md={4} sm={12}>
            <div className={styles.cardSection}>
              <img  loading="lazy" src="/images/Carrer/img_1.png" alt="user" />
              <p>
                At CrossBorder BTC, every day is an opportunity to learn, grow,
                and make a real impact in a supportive and dynamic environment.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default Section;
